class ProductFormModalLink extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Handle fetching all the required elements to display the product form modal
   */
  connectedCallback() {
    this.body = document.body;
    this.modal = document.querySelector('[data-product-form-modal]');
    this.modalContent = this.modal.querySelector('[data-dialog-content]');
    this.modalCloseButton = this.modal.querySelector('[data-close]');
    this.openModalButton = this.querySelector('[data-variants-selector-link]');
    this.productURL = this.dataset.productUrl;
    this.closeModalOnOutsideClick = this.closeModalOnOutsideClick.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.addEventListeners();
  }

  /**
   * Bind event listeners for opening the modal
   */
  addEventListeners() {
    this.openModalButton.addEventListener('click', event => {
      this.openModalButton.classList.add('btn-loading');
      event.preventDefault();
      this.loadModalContent();
    });
  }

  /**
   * Use section rendering to load the product-form-dialog-section
   */
  async loadModalContent() {
    let url = this.productURL;

    const symbol = url.includes('?') ? '&' : '?';
    return fetch(`${url}${symbol}sections=${this.sectionId}`)
      .then(response => response.json())
      .then(responseJson => {
        const newSectionElement = new DOMParser().parseFromString(
          responseJson[this.sectionId],
          'text/html'
        );

        // Replace contents new HTML
        this.replaceContent(newSectionElement);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Error loading modal content:', error);
      });
  }

  /**
   * Replace the HTML received from the section rendering request into the modal
   */
  replaceContent(newElement) {
    this.modalContent.innerHTML = newElement.querySelector(
      `#shopify-section-${this.sectionId}`
    ).parentNode.innerHTML;
    this.loadScripts(newElement);
  }

  /**
   * load all CSS scripts and open modal
   */
  loadScripts(element) {
    for (const scriptElement of element.querySelectorAll('script')) {
      const newScriptElement = document.createElement('script');
      for (const attribute of scriptElement.attributes) {
        newScriptElement.setAttribute(attribute.name, attribute.value);
      }
      scriptElement.parentNode.replaceChild(newScriptElement, scriptElement);
    }
    this.openModalButton.classList.remove('btn-loading');

    setTimeout(() => {
      this.openModal();
    });
  }

  /**
   * Handle closing modal when any other part of the modal is clicked
   */
  closeModalOnOutsideClick(event) {
    if (event.target.closest('.dialog-content')) return;
    this.closeModal();
  }

  /**
   * enable the page scroll when the modal is closed
   */
  enablePageScroll() {
    this.body.toggleAttribute('modal-open', false);
  }

  /**
   * Function to close modal
   */
  closeModal() {
    this.modal.close();
    this.enablePageScroll();
    this.modal.removeEventListener('click', this.closeModalOnOutsideClick);
    this.modalCloseButton.removeEventListener('click', this.closeModal);
  }

  /**
   * Use the dialog section-id
   */
  get sectionId() {
    return 'product-form-modal';
  }

  /**
   * Handle opening the modal
   */
  openModal() {
    this.modal.addEventListener('click', this.closeModalOnOutsideClick);
    this.modalCloseButton.addEventListener('click', this.closeModal);
    this.modal.showModal();
    this.disablePageScroll();
  }

  /**
   * Disable page scroll when the modal is opened
   */
  disablePageScroll() {
    this.body.toggleAttribute('modal-open', true);
  }
}

customElements.define('product-form-modal-link', ProductFormModalLink);
